import { QrItemGetterTypes } from './types';

export const getters = {
    [QrItemGetterTypes.GetQrItemData](state) {
        return state.qr_item_data
    },
}